'use strict';

module.exports = require('../src');


//////////////////
// WEBPACK FOOTER
// ./hysdk.js
// module id = 58
// module chunks = 2 4